import React, { ReactElement, ReactNode, useState } from "react";

import { useIntl } from "gatsby-plugin-react-intl";
import OverlayTrigger, { OverlayTriggerType } from "react-bootstrap/OverlayTrigger";

import UpdatingTooltip from "./updatingTooltip";
import copyToClipboard from "../../utils/clipboardHelper";

interface CopyToClipboardProps {
  children: ReactElement;
  copiedText?: ReactNode;
  copyText?: ReactNode;
  placement?: "top" | "right" | "bottom" | "left";
  textToCopy: string;
  trigger?: OverlayTriggerType | OverlayTriggerType[] | undefined;
}

const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
  children,
  copiedText = undefined,
  copyText = undefined,
  placement = "top",
  textToCopy,
  trigger = ["hover", "focus"],
}) => {
  const intl = useIntl();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [content, setContent] = useState<ReactNode>(copyText || intl.formatMessage({ id: "copy_to_clipboard.copy" }));

  return (
    <OverlayTrigger
      defaultShow={false}
      show={tooltipOpen}
      placement={placement}
      trigger={trigger}
      delay={{ hide: 400, show: 100 }}
      overlay={(params) => <UpdatingTooltip id="copytoclipboard" {...params}>{content}</UpdatingTooltip>}
      onToggle={(visible) => {
        setTooltipOpen(visible);

        if (!visible) {
          setTimeout(() => {
            setContent(copyText || intl.formatMessage({ id: "copy_to_clipboard.copy" }));
          }, 500);
        }
      }}
    >
      {React.cloneElement(children, {
        onClick: () => {
          copyToClipboard(textToCopy, () => {
            setContent(copiedText || intl.formatMessage({ id: "copy_to_clipboard.copied" }));
          });
        },
      })}
    </OverlayTrigger>
  );
};

export default CopyToClipboard;
